var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrinch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_400",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29255",
    "data-name": "Group 29255",
    transform: "translate(138 10935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -138, -10935)",
    filter: "url(#Ellipse_400)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_400-2",
    "data-name": "Ellipse 400",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-grinch",
    transform: "translate(-122.983 -10921.232)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_443",
    "data-name": "Ellipse 443",
    cx: 9.5,
    cy: 8.5,
    rx: 9.5,
    ry: 8.5,
    transform: "translate(10.999 13.466)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50189",
    "data-name": "Path 50189",
    d: "M37.326,11.622s.384-5.2-1.665-6.561c-2.5-1.665-5-.535-6.661-1.367C24.846,1.617,24.837,1,23.172,1c-3.312,0-9.088,9.158-9.088,13.3l16.3-.08c0-2.316-2.22-7.493-2.22-7.493,5,0,7.533,5.085,7.533,5.085Z",
    transform: "translate(-1.689)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50190",
    "data-name": "Path 50190",
    d: "M35.307,31.289c0,8.4-14.154,11.656-14.154,11.656S7,39.689,7,31.289c0-4.782,5.877-3.33,14.154-3.33S35.307,26.506,35.307,31.289Z",
    transform: "translate(-0.502 -4.479)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50191",
    "data-name": "Path 50191",
    d: "M35.263,26.017s5-.852,6.661,6.642c0,0-.753-.48-1.673-.955a8.929,8.929,0,0,1,.839,4.283L39.28,34.16a10.6,10.6,0,0,1-.326,3.491l-1.193-1.968a3.306,3.306,0,0,1-1.665,2.8v-2.5L31.555,37.1Z",
    transform: "translate(-4.614 -4.184)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50192",
    "data-name": "Path 50192",
    d: "M10.66,26.017s-5-.852-6.661,6.642c0,0,.753-.48,1.673-.955a8.929,8.929,0,0,0-.839,4.283l1.81-1.827a10.629,10.629,0,0,0,.326,3.491L8.163,35.7a3.29,3.29,0,0,0,1.665,2.791v-2.5L14.369,37.1Z",
    transform: "translate(0 -4.184)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_444",
    "data-name": "Ellipse 444",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(25.999 21.466)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_445",
    "data-name": "Ellipse 445",
    cx: 4.5,
    cy: 5,
    rx: 4.5,
    ry: 5,
    transform: "translate(5.999 21.466)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50193",
    "data-name": "Path 50193",
    d: "M44.22,15.61a1,1,0,0,0,.383-1.159v.007a1.007,1.007,0,0,0-1.021-.672.99.99,0,0,0-.456-1.119,1,1,0,0,0-1.214.141,1.01,1.01,0,0,0-1.919.319,1.011,1.011,0,0,0-1.187.26,1,1,0,0,0-.062,1.219.993.993,0,0,0-.744.958,1,1,0,0,0,.671.945.987.987,0,0,0,.067,1.152,1.01,1.01,0,0,0,1.181.3,1,1,0,0,0,.812.912.963.963,0,0,0,.195.013,1.008,1.008,0,0,0,.9-.546,1.019,1.019,0,0,0,1.207.181,1.008,1.008,0,0,0,.5-1.112,1.006,1.006,0,0,0,1.041-.639A.983.983,0,0,0,44.22,15.61Z",
    transform: "translate(-5.693 -1.879)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8462",
    "data-name": "Rectangle 8462",
    width: 17.9,
    height: 4.995,
    transform: "translate(11.909 12.24)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_446",
    "data-name": "Ellipse 446",
    cx: 1.5,
    cy: 1,
    rx: 1.5,
    ry: 1,
    transform: "translate(27.999 11.466)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_447",
    "data-name": "Ellipse 447",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(25.999 11.466)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 1.5,
    cy: 1,
    rx: 1.5,
    ry: 1,
    transform: "translate(22.999 11.466)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_449",
    "data-name": "Ellipse 449",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(27.999 13.466)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_450",
    "data-name": "Ellipse 450",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(10.66 13.54)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_451",
    "data-name": "Ellipse 451",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(10.66 11.042)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_452",
    "data-name": "Ellipse 452",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(13.158 11.042)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_453",
    "data-name": "Ellipse 453",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(15.656 11.042)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_454",
    "data-name": "Ellipse 454",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(18.154 11.042)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_455",
    "data-name": "Ellipse 455",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(20.999 11.466)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_456",
    "data-name": "Ellipse 456",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(28.144 16.038)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_457",
    "data-name": "Ellipse 457",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(25.647 16.038)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_458",
    "data-name": "Ellipse 458",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(23.149 16.038)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_459",
    "data-name": "Ellipse 459",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(10.66 16.038)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_460",
    "data-name": "Ellipse 460",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(13.158 16.038)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_461",
    "data-name": "Ellipse 461",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(15.656 16.038)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_462",
    "data-name": "Ellipse 462",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(18.154 16.038)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_463",
    "data-name": "Ellipse 463",
    cx: 1.249,
    cy: 1.249,
    r: 1.249,
    transform: "translate(20.651 16.038)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50194",
    "data-name": "Path 50194",
    d: "M30,7.731S25.831,8.667,25,7c0,0,.51,2.742,5.691,2.468C30.485,8.9,30,7.731,30,7.731Z",
    transform: "translate(-3.516 -1.005)",
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 2.5,
    cy: 1,
    rx: 2.5,
    ry: 1,
    transform: "translate(17.999 26.466)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_465",
    "data-name": "Ellipse 465",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(22.999 21.466)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_466",
    "data-name": "Ellipse 466",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(12.999 21.466)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_467",
    "data-name": "Ellipse 467",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(23.999 22.466)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 0.5,
    cy: 1,
    rx: 0.5,
    ry: 1,
    transform: "translate(15.999 22.466)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50195",
    "data-name": "Path 50195",
    d: "M31.493,24.836C27.7,24.836,27.33,29,25.665,29,24.321,29,24,27.334,24,27.334a1.153,1.153,0,0,0,1.665,0c.624-.624,1.721-2.919,3.053-3.214A2.62,2.62,0,0,1,31.493,24.836Z",
    transform: "translate(-3.349 -3.855)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50196",
    "data-name": "Path 50196",
    d: "M15,24.834c3.795,0,4.163,4.163,5.828,4.163,1.335,0,1.665-1.665,1.665-1.665a1.153,1.153,0,0,1-1.665,0c-.624-.624-1.721-2.932-3.053-3.227A2.611,2.611,0,0,0,15,24.834Z",
    transform: "translate(-1.842 -3.852)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_469",
    "data-name": "Ellipse 469",
    cx: 3.5,
    cy: 4,
    rx: 3.5,
    ry: 4,
    transform: "translate(25.999 23.466)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50197",
    "data-name": "Path 50197",
    d: "M36.665,30A1.665,1.665,0,0,0,35,31.665h3.33A1.665,1.665,0,0,0,36.665,30Z",
    transform: "translate(-5.191 -4.855)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_470",
    "data-name": "Ellipse 470",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(7.999 23.466)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50198",
    "data-name": "Path 50198",
    d: "M10.665,30A1.665,1.665,0,0,0,9,31.665h3.33A1.665,1.665,0,0,0,10.665,30Z",
    transform: "translate(-0.837 -4.855)",
    fill: "#0b420d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50199",
    "data-name": "Path 50199",
    d: "M21.65,41.048l-5.368-2.684c-7.175-3.588-6.3-7.445-6.263-7.607l1.614.4c0,.007-.468,2.783,5.393,5.714l4.622,2.312,4.623-2.311c5.86-2.931,5.393-5.706,5.388-5.734l1.619-.384c.041.162.912,4.02-6.263,7.607Z",
    transform: "translate(-0.999 -4.982)",
    fill: "#0b420d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrinch);
export default __webpack_public_path__ + "static/media/grinch.b24b079cc02c023beadbeb32af353e4b.svg";
export { ForwardRef as ReactComponent };